/**
 * 백서 4.11.1: 가입 시 선택한 국가에 따라 어떤 인증 수단을 기본 옵션으로 제시할지 결정한다.
 * 지금은 한국/영어권은 구글·MS를 지원하고, 중국(WeCom·알리페이)·EU(EUDI Wallet)는
 * MVP에서 아직 미구현이라 "추후 지원"으로 비활성 표시한다(로드맵 9.2).
 */
const EU_MEMBER_ISO2 = new Set([
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE",
  "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE",
]);

export type SignupProviderBucket = "china" | "eu" | "default";

export function classifyCountryForSignupProviders(iso2Country: string): SignupProviderBucket {
  const code = iso2Country.toUpperCase();
  if (code === "CN") return "china";
  if (EU_MEMBER_ISO2.has(code)) return "eu";
  return "default";
}
